import { FC } from 'react';

import { EntityRelationDTO } from '../../type';
import { MultilevelColumn, TableContainer, TableMultilevel } from '../table';

type Props = {
  values: EntityRelationDTO[];
  loading: boolean;
};

const EntityRelationTable: FC<Props> = ({ values, loading }) => {
  return (
    <TableContainer>
      <TableMultilevel<EntityRelationDTO>
        values={values}
        childrenExtractor={value => value.childrens || []}
        keyExtractor={value => `${value.tipo}-${value.identificador}`}
        loading={loading}
        highlightError={value => value.restringeExclusao}
      >
        <MultilevelColumn<EntityRelationDTO>
          name="tipo"
          header="Tipo"
          value={value => value.tipo}
        />
        <MultilevelColumn<EntityRelationDTO>
          name="identificador"
          header="Identificador"
          value={value => (
            <span style={{ whiteSpace: 'pre-wrap' }}>
              {value.identificador}
            </span>
          )}
        />
      </TableMultilevel>
      <div className="subtitles">
        <div className="subtitle negative">Não permitem exclusão</div>
      </div>
    </TableContainer>
  );
};

export default EntityRelationTable;
